import { useMemo } from "react";
import buildMediaFileCharacters from "../common/buildMediaFileCharacters";
/**
 * The chatbot, personas and profile a file is shown with, read straight from the response. The chatbot comes
 * from the file's embed and the others arrive named in its connections, each entry with a `type`. The backend
 * has already decided which of them this caller may see, so there is nothing left to ask a second endpoint for.
 */
export default function useMediaFileCharacters({ file }) {
    return useMemo(() => buildMediaFileCharacters(file), [file]);
}
